import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Timer, Trophy, Zap, Users2 } from "lucide-react";
import client from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { SectionTitle, Card, Pill, Zig, Loading } from "../components/common";
import { AdSlot } from "../components/AdSlot";
import { SupportClubs } from "../components/SupportClubs";

export function FantasyHub() {
  const { user } = useAuth();
  const [cfg, setCfg] = useState(null);
  const [board, setBoard] = useState([]);
  useEffect(() => {
    client.get("/fantasy/config").then((r) => setCfg(r.data));
    client.get("/fantasy/leaderboard").then((r) => setBoard(r.data)).catch(() => {});
  }, []);
  if (!cfg) return <Loading />;
  return (
    <div data-testid="fantasy-hub" className="space-y-6">
      <AdSlot id="fantasy.deadline" height={120} />
      <div className="bg-green text-cream rounded-sm p-8 grain relative overflow-hidden">
        <Trophy className="absolute -right-8 -bottom-8 text-gold/20" size={200} />
        <Pill tone="gold">Gameweek {cfg.gameweek}</Pill>
        <h1 className="font-head font-black text-3xl md:text-4xl mt-3 tracking-tight">PSL Fantasy</h1>
        <p className="text-cream/80 mt-2">Build a 15-player squad within a <Zig value={cfg.budget} className="text-gold font-bold" /> budget. Free to play, priced in ZiG.</p>
        <div className="flex flex-wrap gap-6 mt-5">
          <div><div className="text-xs text-cream/60 uppercase tracking-wider flex items-center gap-1"><Timer size={12} /> Deadline</div><div className="font-head font-bold text-gold">{new Date(cfg.deadline).toLocaleString("en-GB", { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</div></div>
          <div><div className="text-xs text-cream/60 uppercase tracking-wider">Squad</div><div className="font-head font-bold">15 · max 3/club</div></div>
        </div>
        <div className="flex gap-3 mt-6">
          <Link to="/fantasy/pick" data-testid="fantasy-pick-cta" className="px-5 py-2.5 bg-gold text-ink font-bold rounded-sm hover:bg-cream transition-colors">{user ? "Pick / edit squad" : "Build a team"}</Link>
          <Link to="/fantasy/chat" className="px-5 py-2.5 border-2 border-gold text-gold font-bold rounded-sm hover:bg-gold hover:text-ink transition-colors">Fantasy chat</Link>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <Card className="p-5"><Zap className="text-gold mb-2" /><div className="font-head font-bold text-green">Chips</div><p className="text-sm text-ink/60 mt-1">{cfg.chips.join(", ")}. Two halves of the season.</p></Card>
        <Card className="p-5"><Users2 className="text-gold mb-2" /><div className="font-head font-bold text-green">Mini-leagues</div><p className="text-sm text-ink/60 mt-1">Global leaderboard + private & branded mini-leagues.</p></Card>
        <Card className="p-5"><Trophy className="text-gold mb-2" /><div className="font-head font-bold text-green">Transfers</div><p className="text-sm text-ink/60 mt-1">One free transfer per GW; hits cost points, not money.</p></Card>
      </div>

      <div>
        <SectionTitle kicker="Global">Leaderboard</SectionTitle>
        <Card className="divide-y divide-pslborder">
          {board.length === 0 && <p className="p-4 text-sm text-ink/50">No squads yet — be the first to enter.</p>}
          {board.slice(0, 20).map((s) => (
            <div key={s.rank} className="flex items-center gap-3 px-4 py-2.5" data-testid={`lb-${s.rank}`}>
              <span className={`w-6 font-head font-bold ${s.rank <= 3 ? "text-gold" : "text-ink/40"}`}>{s.rank}</span>
              <span className="flex-1 font-semibold text-sm">{s.team_name} <span className="text-ink/40 font-normal">· {s.username}</span></span>
              <span className="font-head font-bold text-green tabular">{s.points} pts</span>
            </div>
          ))}
        </Card>
      </div>

      <SupportClubs />
    </div>
  );
}
